import { createApp } from 'vue/dist/vue.esm-bundler';
import Projects from './Projects.vue';


const mountEl = document.querySelector('[data-app-projects-list]');

if ( mountEl )
{
    createApp(Projects, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}